// src/components/NavLinks.js
import React from 'react';
import { Box, Link, Typography, useTheme } from '@mui/material';
import { useLocation } from 'react-router-dom';

const NavLinks = () => {
    const theme = useTheme();
    const location = useLocation();

    const linkStyles = (isSelected) => ({
        color: isSelected ? "text.primary" : "text.secondary",
        textDecoration: 'none',
        marginRight: theme.spacing(3),
        position: 'relative',
        paddingBottom: theme.spacing(0.5),
        '&:hover': {
            color: "text.primary",
        },
        '&::after': {
            content: '""',
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '100%',
            // height: '2px',
            // backgroundColor: isSelected ? "text.primary" : 'transparent',
            transition: 'background-color 0.3s',
        },
    });

    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {[
                { label: 'Home', path: '/home' },
                { label: 'About', path: '/about' },
                // { label: 'Services', path: '/services' },
                { label: 'Contact', path: '/contact' },
                { label: 'FAQ', path: '/faq' },
                // { label: 'Pricing', path: '/pricing' },
                { label: 'Terms', path: '/terms' },
                { label: 'Privacy', path: '/privacy' },
            ].map((link) => (
                <Link
                    key={link.path}
                    href={link.path}
                    sx={linkStyles(location.pathname === link.path)}
                >
                    <Typography
                        variant="body1"
                        sx={{ fontWeight: 500 }}  // Apply fontWeight here
                    >
                        {link.label}
                    </Typography>
                </Link>
            ))}
        </Box>
    );
};

export default NavLinks;
